export const MAX_PICTOS_TO_SHOW = 10
export const DATA_BANNER_TYPE = 'Categories Shelf'

export const PICTO_ITEM_CLASS_NAME =
  'flex flex-col justify-center items-center w-[73px] restructure-small-desktop:w-[92px]'

export type PictosHomeItemData = {
  image: string
  textColor?: 'preto' | 'branco'
  text: string
  altImage: string
  linkUrl: string
  isMuseEntryPoint?: boolean
}
